export const updateItemByField = <T extends Record<string, any>, TNewValue extends T>(
  array: T[],
  newValue: TNewValue,
  findConfiguration: { [K in keyof T]?: T[K] } = {},
): T[] => {
  const [field, value] = Object.entries(findConfiguration)[0];

  return array.map((item) => (item[field] === value ? newValue : item));
};
